import React from "react";
import vege from "../img/vege.jpg";
function Product() {
  return (
    <section
      className="grid grid-cols-1 md:grid-cols-2 gap-2 w-full "
      id="aqua"
    >
      <div className="py-2 flex-1 flex items-center relative">
        {
          <img
            src={vege}
            className="ml-auto h-420 w-full lg:w-auto lg:h-300"
            alt="img"
          />
        }
      </div>
      <div className="py-2 flex-1 flex flex-col items-start justify-center gap-6">
        <p className="text-[2rem] lg:text-[2rem] font-bold tracking-wide text-slate-700">
        Every day, almost 40 million litres of wastewater 
        </p>
        <p className="text-base text-slate-400 text-center md:text-left md:w-[80%]">
          Every day, almost 40 million litres of wastewater enters rivers and
          other bodies with only a tiny fraction adequately treated. water 80%
          of ocean pollution (also called marine pollution) originates on land-
          whether along the coast or far inland. Contaminants such as chemicals,
          nutrients, and heavy metals are carried from farms, factories, and
          cities by streams and rivers into our bays and estuaries; from there
          they travel out to sea. For fish to have good health, avoid stress or
          disease the quality of the water must be monitored and controlled at
          all times. This product is the solution towards bad water quality. The
          main purpose of the product is to make a low cost, less complex
          solution to help the fish farmers in India test the water quality
          requirements depending upon the fish breed. This will further help us
          to maintain the water clean by using pH sensor, temperature sensor and
          turbidity sensor. These Water quality records via ph, temperature,
          turbidity sensors will allow farmers to note changes and make
          decisions fast so that required actions can be taken immediately. The
          product also has an external setup for the cleaning of water,
          especially for the aquarium purpose. This external setup provides a
          filtration system that helps the process of cleaning. This basically
          increases the time period for the physical cleaning of tanks. The
          setup comes with two types of filtration that is aquaponics and 50%
          water change. Plants yielding fruit have higher nutritional
          requirements, and although they grow well in aquaponics systems, they
          need to be placed in systems that are heavily stocked and well
          established. Aside from plants and fish, the other major component of
          aquaponics is the water itself. That said, carefully monitoring the
          water's pH, which determines acidity, is of the utmost importance to
          ensure safe levels for the fish. Water quality testing equipment is
          very important to ensure that both fish and plants remain healthy. The
          product with the whole setup performs in three domains: water quality
          monitoring, filtration of water and aquaponics monitoring. Aquaponics
          system constantly monitors and analyses the conditions of fish and
          plants, takes automated restorative actions to balance the aberrations
          based on data and qualitatively differ from the collected data to
          improve the conditions for operations, risk reduction and manual
          intervention for the setup of the fish. Real time overview of the
          different parameters collected from the water such as temperature, pH
          and turbidity.
        </p>
      </div>
    </section>
  );
}

export default Product;
